import axios from "./axios"

/**
 * 獲取公眾問卷
 * @param {*} lang 
 */
const list = (lang = 'ZH_TW') => {
    return axios.get(`/questionnaires?lang=${lang}`).then(res => res.data)
}

/**
 * 用戶提交課程問卷
 * @param {*} answerValues 
 * @param {*} lang 
 */
const submit = (answerValues, captcha, lang = 'ZH_TW') => {
    return axios.post(`/questionnaires/submit?captcha=${captcha}&lang=${lang}`, answerValues).then(res => res.data)
}

/**
 * 用戶參與課程問卷
 * @param {*} lang 
 */
const listQuestionByQuestionnaire = (questionnaireId, lang = 'ZH_TW', group) => {
    return axios.get(`/questionnaires/${questionnaireId}/questions?lang=${lang}${group ? `&group=${group}`:''}`).then(res => res.data)
}

/**
 * 驗證碼
 */
const captcha = () => {
    return axios.get(`/servlet/captcha`, {
        responseType: "arraybuffer"
    }).then(res => res.data)
}

export default {
    list,
    submit,
    listQuestionByQuestionnaire,
    captcha
}